module.exports = __webpack_public_path__ + "media/images/plans/kaoawase/about-c6822d05e6d1a8c29d4d58be66e1b121.jpg";